export default __webpack_public_path__ + "static/media/Bangles-Making-Charge-List.3fcbda35.jpg";